import React, {createContext, useState, useEffect} from 'react';
import { supabase } from './supabaseClient';
import { getOrCreateDatabaseUser } from './services/userMappingService';

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize userId from Supabase session on app startup.
  //
  // Race fix 2026-04-23: clear stale `localStorage.userId` SYNCHRONOUSLY
  // before the async supabase.auth.getSession() call. Previously, any
  // legacy userId left in localStorage (from a prior session, or from
  // the unified AuthModal writing it without creating a Supabase session)
  // would appear to unified screens that read localStorage directly
  // (UnifiedMyTable, UnifiedRewards) during the 500ms+ window before
  // Supabase's session check resolved. On mobile that window is wider,
  // so users saw a "ghost logged in" state. We re-populate userId only
  // if Supabase confirms the session is still valid.
  useEffect(() => {
    if (localStorage.getItem('userId')) {
      localStorage.removeItem('userId');
    }

    const initializeUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();

        if (session?.user) {
          // Active Supabase session — restore the legacy userId mapping.
          const legacyUserId = await getOrCreateDatabaseUser();
          if (legacyUserId) {
            localStorage.setItem('userId', `${legacyUserId}`);
            setUserId(legacyUserId);
          }
        }
        // No session → localStorage is already cleared above. Nothing
        // more to do; the user will sign in through /login when ready.
      } catch (error) {
        console.error('Failed to initialize user:', error);
      } finally {
        setIsInitialized(true);
      }
    };

    initializeUser();
  }, []);

  return (
    <UserContext.Provider value={{ userId, setUserId, isInitialized }}>
      {children}
    </UserContext.Provider>
  );
};

export {UserContext, UserProvider};